import {
  A11y,
  Keyboard,
} from 'swiper';

import Swiper from 'swiper/core/core';

import './productGallery.scss';

Swiper.use([
  A11y,
  Keyboard,
]);

const SELECTOR_SIZE = '.js-productGallerySize';
const SELECTOR_THUMB = '.js-productGalleryThumb';
const SELECTOR_SLIDER = '.js-productGallerySlider';
const SELECTOR_OPTION = '.js-option';
const SELECTOR_GALLERY_ITEM = '.js-productGalleryItem';
const INITIAL_STATE = {
  sliders: [],
};
let state = { ...INITIAL_STATE };

const onThumbClick = function onProductGalleryThumbClick(ev) {
  const index = parseInt(ev.currentTarget.getAttribute('data-index') || 1, 10) - 1;

  state.sliders[0].slideTo(index, 400);
};

const markActiveThumb = function markGalleryActiveThumb({
  swiper,
  parent,
}) {
  const { activeIndex } = swiper;

  [].forEach.call(
    parent.querySelectorAll(SELECTOR_THUMB),
    (thumb, i) => {
      const index = thumb ? (Number(thumb.getAttribute('data-index')) - 1) : -1;
      thumb.classList[index === activeIndex ? 'add' : 'remove']('is-selected');
    },
  );
};

const onSizeChange = (ev) => {
  const id = ev.target.value;
  const thumb = document.querySelector(`${SELECTOR_THUMB}[data-ids*="${id}"]`);
  const index = thumb
    ? parseInt(thumb.getAttribute('data-index') || 1, 10) - 1
    : 0;

  state.sliders[0].slideTo(index, 400);
};

const filterGallery = () => {
  const galleryImages = document.querySelectorAll(`${SELECTOR_GALLERY_ITEM}[data-filterable="true"]`);
  const options = document.querySelectorAll('.js-options');
  let canFilter = true;
  let result = '';

  options.forEach((el) => {
    const selected = el.querySelector('.js-option:checked');
    const option = selected ? selected.getAttribute('data-title') : null;

    if (option) {
      result += '/';
      result += option;
    } else {
      canFilter = false;
    }
  });

  if (canFilter && result) {
    result += '/';
  }

  galleryImages.forEach((image) => {
    const imageAlt = image.getAttribute('data-alt');

    if (canFilter && result && imageAlt) {
      const formattedAlt = `/${ imageAlt.replace(/\s\/\s/g, '/') }/`;
      const imageIsValid = isValidImageForFilter(result, formattedAlt);

      if (imageIsValid) {
        image.classList.remove('hidden');
      } else {
        image.classList.add('hidden');
      }
    } else {
      image.classList.remove('hidden');
    }
  });

  state.sliders.forEach((slider) => {
    slider.updateSlides();
  });

  reIndexThumbs();
};


const isValidImageForFilter = ((result, alt) => {
  let isValid = true;

  alt.split('/').forEach((str) => {
    if (str) {
      const formatted = `/${ str }/`;

      if (!result.includes(formatted)) {
        isValid = false;
      }
    }
  });

  return isValid;
});


const reIndexThumbs = () => {
  const galleryImages = document.querySelectorAll(SELECTOR_GALLERY_ITEM);
  let startIndex = 0;
  let currentIndex = 1;
  let firstSlide = null;

  galleryImages.forEach((el) => {
    const hiddenImage = el.classList.contains('hidden');
    const thumb = el.querySelector('.js-productGalleryThumb');

    if (thumb && hiddenImage) {
      thumb.setAttribute('data-index', 0);
      if (thumb.classList.contains('is-selected')) {
        thumb.classList.remove('is-selected');
      }
    } else if (thumb) {
      thumb.setAttribute('data-index', currentIndex);

      if (!firstSlide) {
        firstSlide = thumb;
      }

      if (thumb.classList.contains('is-selected')) {
        startIndex = currentIndex - 1;
      }

      currentIndex += 1;
    }
  });

  if (startIndex == 0 && firstSlide) {
    firstSlide.classList.add('is-selected');
  }

  // console.log('START');
  // console.log(startIndex);


  state.sliders.forEach((slider) => {
    slider.slideTo(startIndex, 0);
  });
};

const bind = function bindProductGallery() {
  [].forEach.call(
    document.querySelectorAll(SELECTOR_SLIDER),
    (el) => {
      const swiper = new Swiper(el, {
        navigation: false,
        pagination: false,
      });

      swiper.on('slideChange', () => markActiveThumb({
        swiper,
        parent: el.parentNode,
      }));

      state.sliders.push(swiper);
    },
  );

  [].forEach.call(
    document.querySelectorAll(SELECTOR_THUMB),
    (el) => {
      el.addEventListener('click', onThumbClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll(SELECTOR_SIZE),
    (el) => {
      el.addEventListener('change', onSizeChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll(SELECTOR_OPTION),
    (el) => {
      el.addEventListener('change', filterGallery);
    },
  );
};

const init = function initProductGallery() {
  bind();
};

const destroy = function destroyProductGallery() {
  state.sliders.forEach((slider) => {
    slider.destroy();
  });
  state = { ...INITIAL_STATE };

  [].forEach.call(
    document.querySelectorAll(SELECTOR_THUMB),
    (el) => {
      el.removeEventListener('click', onThumbClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll(SELECTOR_SIZE),
    (el) => {
      el.removeEventListener('change', onSizeChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll(SELECTOR_OPTION),
    (el) => {
      el.removeEventListener('change', filterGallery);
    },
  );
};

export default {
  destroy,
  init,
};
